module.exports = __webpack_public_path__ + "e8a37541a19e428459feafc071894ec2.pdf";